module.exports = __webpack_public_path__ + "static/img/26.bd1bd5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/26.png
// module id = g0Nt
// module chunks = 0